import { ReactComponent } from './images/CloseIcon.svg'

export const CloseIcon = ReactComponent
